import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const PrintIcon = () => <FontAwesomeIcon icon={["fas", "print"]}/>

export default PrintIcon;